export default __webpack_public_path__ + "static/media/on-vessel-at-berth.bfa0c34b.svg";